import React, { useEffect } from 'react'
import { Row, Col } from 'antd'
import { IconExclamationMark } from '@edulastic/icons'
import { ChangeQTypeOptions } from '../../constants'
import {
  IconContainer,
  StyledInfoContainer,
  StyledInfoTextContainer,
  StyledQuestionTypeList,
  StyledQuestionTypeListItem,
  StyledQuestionTypeItemContent,
  StyledQuestionTypeItemText,
  StyledIconWrapper,
} from './styled'

const SelectQTypeOption = ({
  onQuestionTypeSelect,
  isQuestionTypeChangePopupVisible = false,
  onClosePopover,
  isKeyboardUser = false,
}) => {
  useEffect(() => {
    if (
      isKeyboardUser &&
      isQuestionTypeChangePopupVisible &&
      ChangeQTypeOptions.length > 0
    ) {
      const firstOptionId = `${ChangeQTypeOptions[0].key}-option`
      const firstElement = document.getElementById(firstOptionId)

      if (firstElement) {
        setTimeout(() => {
          firstElement.focus()
        }, 0)
      }
    }
  }, [isQuestionTypeChangePopupVisible])

  const handleKeyDown = (e, key, index) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onQuestionTypeSelect(key)
    } else if (
      e.key === 'Tab' &&
      !e.shiftKey &&
      index === ChangeQTypeOptions.length - 1
    ) {
      // If this is the last option and user presses Tab, close the popover
      e.preventDefault()
      onClosePopover()
      // Find the trigger element and focus it after a short delay
      setTimeout(() => {
        const triggerElement = document.querySelector(
          '[data-joyride-id="changeQuestionType"] [role="button"]'
        )
        if (triggerElement) {
          triggerElement.focus()
        }
      }, 0)
    } else if (e.key === 'Tab' && e.shiftKey && index === 0) {
      e.preventDefault()
      onClosePopover()
      setTimeout(() => {
        const triggerElement = document.querySelector(
          '[data-joyride-id="changeQuestionType"] [role="button"]'
        )
        if (triggerElement) {
          triggerElement.focus()
        }
      }, 0)
    }
  }

  return (
    <>
      <StyledInfoContainer>
        <Col span={2} style={{ lineHeight: '32px' }}>
          <Row type="flex" align="center">
            <Col>
              <IconExclamationMark
                backgroundColor="#ECAB28"
                foregroundColor="black"
              />
            </Col>
          </Row>
        </Col>
        <Col span={22}>
          <StyledInfoTextContainer>
            Change item type - Only question, standards, and rubric will carry
            over.
          </StyledInfoTextContainer>
        </Col>
      </StyledInfoContainer>
      <StyledQuestionTypeList role="list" aria-label="Question type options">
        {ChangeQTypeOptions.map(({ key, icon, title }, index) => {
          return (
            <StyledQuestionTypeListItem key={key}>
              <StyledQuestionTypeItemContent
                onClick={() => onQuestionTypeSelect(key)}
                role="button"
                aria-label={title}
                tabIndex="0"
                id={index === 0 ? `${key}-option` : undefined}
                onKeyDown={(e) => handleKeyDown(e, key, index)}
              >
                <StyledIconWrapper>
                  <IconContainer>{icon}</IconContainer>
                </StyledIconWrapper>
                <StyledQuestionTypeItemText>
                  <span style={{ fontWeight: '600' }}>{title}</span>
                </StyledQuestionTypeItemText>
              </StyledQuestionTypeItemContent>
            </StyledQuestionTypeListItem>
          )
        })}
      </StyledQuestionTypeList>
    </>
  )
}

export default SelectQTypeOption
